module.exports = __webpack_public_path__ + "img/vue-js-large.9f253673.png";